import { FaUserCheck, FaPlug, FaTruckMoving, FaCheckCircle } from "react-icons/fa";

export default function Timeline() {
  const businessEvents = [
    {
      id: 1,
      title: "Sign Up & Get Approved",
      icon: <FaUserCheck />,
      disc:
        "Joining Tuber is simple. Fill out our online form, and our team will set up your business account within 24 hours.",
    },
    {
      id: 2,
      title: "Plug into the Tuber Network",
      icon: <FaPlug />,
      disc:
        "Access our user-friendly platform via API integration or web portal. Manage orders, set delivery timeframes, and track shipments in real-time.",
    },
    {
      id: 3,
      title: "Start Booking Deliveries",
      icon: <FaTruckMoving />,
      disc:
        "Schedule deliveries in advance or request an on-demand pickup. Our vast network of vetted drivers ensures your goods get where they need to be—fast.",
    },
    {
      id: 4,
      title: "Track & Confirm",
      icon: <FaCheckCircle />,
      disc:
        "Monitor every step of your delivery with live tracking and instant proof of delivery, giving you and your customers complete confidence.",
    },
  ];

  return (
    <div className="px-5 py-8 md:py-12 max-w-4xl mx-auto">
      <h1 className="text-3xl md:text-4xl font-bold text-center mb-10 md:mb-16 text-headings">
        How It Works
      </h1>

      {/* Timeline */}
      <div className="relative">
        {/* Vertical timeline bar */}
        <div className="absolute left-0 md:left-1/2 transform -translate-x-1/2 h-full w-1 bg-primary opacity-20"></div>

        {/* Timeline events */}
        {businessEvents.map((event, index) => (
          <div
            key={event.id}
            className="flex pb-10 md:pb-16 timeline pl-6 md:pl-0 flex-col md:flex-row"
          >
            {/* Left content */}
            <div className="md:w-5/12 text-left">
              <span className="text-sm font-bold text-btn_hover uppercase">{`Step 0${event.id}`}</span>
              <h3 className="text-lg md:text-xl font-semibold text-headings">
                {event.title}
              </h3>
            </div>

            {/* Center dot */}
            <div className="w-[17%] flex justify-start md:justify-center absolute md:relative -left-3 md:left-auto">
              <div className="w-6 h-6 rounded-full bg-primary z-40"></div>
            </div>

            {/* Right content */}
            <div className="md:w-5/12 flex gap-2 md:gap-3 mt-2 md:mt-0">
              <div className="h-10 flex items-center justify-center text-primary text-2xl md:text-3xl">
                {event.icon}
              </div>

              <p className="flex-1 text-sm md:text-lg font-medium text-light_black pt-1">
                {event.disc}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
